export const INVESTMENT_PANEL_TOUCHED = 'investmentPanelTouched'
export const VAULTS_LIST_FILTERS_TOUCHED = 'vaultsListFiltersTouched'
export const CHART_EXPLORER_TOUCHED = 'chartExplorerTouched'
export const VAULTS_LIST_FILTERS_OPEN = 'vaultsListFiltersOpen'
export const BOOKMARKED_VAULTS = 'bookmarkedVaults'
export const OPTIMIZER_FILTERS_OPEN = 'optimizerFiltersOpen'
export const OPTIMIZER_FILTERS_TOUCHED = 'optimizerFiltersTouched'
export const APP_BANNER_CLOSED = 'appBannerClosed'
